import BigInteger from "./BigInteger";
import global from "aws-sdk/global";
import config from "./config.js";

const AuthenticatioHelper = {
  initN:
    "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD1" +
    "29024E088A67CC74020BBEA63B139B22514A08798E3404DD" +
    "EF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245" +
    "E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7ED" +
    "EE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3D" +
    "C2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F" +
    "83655D23DCA3AD961C62F356208552BB9ED529077096966D" +
    "670C354E4ABC9804F1746C08CA18217C32905E462E36CE3B" +
    "E39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9" +
    "DE2BCBF6955817183995497CEA956AE515D2261898FA0510" +
    "15728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64" +
    "ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7" +
    "ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6B" +
    "F12FFA06D98A0864D87602733EC86A64521F2B18177B200C" +
    "BBE117577A615D6C770988C0BAD946E208E24FA074E5AB31" +
    "43DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF",
  N: null,
  g: null,
  k: null,
  smallAValue: null,
  infoBits: null,
  UHexHash: "",
  UValue: null,
  largeAValue: "",
  poolName: "",
  getNowString() {
    var monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var weekNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    var now = new Date();

    var weekDay = weekNames[now.getUTCDay()];
    var month = monthNames[now.getUTCMonth()];
    var day = now.getUTCDate();

    var hours = now.getUTCHours();
    if (hours < 10) {
      hours = "0" + hours;
    }

    var minutes = now.getUTCMinutes();
    if (minutes < 10) {
      minutes = "0" + minutes;
    }

    var seconds = now.getUTCSeconds();
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    var year = now.getUTCFullYear();

    // ddd MMM D HH:mm:ss UTC YYYY
    var dateNow =
      weekDay +
      " " +
      month +
      " " +
      day +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds +
      " UTC " +
      year;

    return dateNow;
  },
  calculateA(a, callback) {
    this.g.modPow(a, this.N, (err, A) => {
      if (err) {
        callback(err, null);
      }

      if (A.mod(this.N).equals(BigInteger.ZERO)) {
        callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
      }

      callback(null, A);
    });
  },
  getLargeAValue(callback) {
    if (this.largeAValue) {
      callback(null, this.largeAValue);
    } else {
      this.calculateA(this.smallAValue, (err, largeAValue) => {
        if (err) {
          callback(err, null);
        }

        this.largeAValue = largeAValue;
        callback(null, this.largeAValue);
      });
    }
  },
  calculateU(A, B) {
    this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
    const finalU = new BigInteger(this.UHexHash, 16);

    return finalU;
  },
  hash(buf) {
    const hashHex = global.util.crypto.sha256(buf, "hex");
    return new Array(64 - hashHex.length).join("0") + hashHex;
  },
  hexHash(hexStr) {
    return this.hash(new global.util.Buffer(hexStr, "hex"));
  },
  padHex(bigInt) {
    let hashStr = bigInt.toString(16);
    if (hashStr.length % 2 === 1) {
      hashStr = `0${hashStr}`;
    } else if ("89ABCDEFabcdef".indexOf(hashStr[0]) !== -1) {
      hashStr = `00${hashStr}`;
    }
    return hashStr;
  },
  getSmallAValue() {
    return this.smallAValue;
  },
  generateRandomSmallA() {
    const hexRandom = global.util.crypto.lib.randomBytes(128).toString("hex");

    const randomBigInt = new BigInteger(hexRandom, 16);
    const smallABigInt = randomBigInt.mod(this.N);

    return smallABigInt;
  },
  calculateS(xValue, serverBValue, callback) {
    this.g.modPow(xValue, this.N, (err, gModPowXN) => {
      if (err) {
        callback(err, null);
      }

      const intValue2 = serverBValue.subtract(this.k.multiply(gModPowXN));
      intValue2.modPow(
        this.smallAValue.add(this.UValue.multiply(xValue)),
        this.N,
        (err2, result) => {
          if (err2) {
            callback(err2, null);
          }

          callback(null, result.mod(this.N));
        }
      );
    });
  },
  computehkdf(ikm, salt) {
    const prk = global.util.crypto.hmac(salt, ikm, "buffer", "sha256");
    const infoBitsUpdate = global.util.buffer.concat([
      this.infoBits,
      new global.util.Buffer(String.fromCharCode(1), "utf8"),
    ]);
    const hmac = global.util.crypto.hmac(
      prk,
      infoBitsUpdate,
      "buffer",
      "sha256"
    );
    return hmac.slice(0, 16);
  },
  getPasswordAuthenticationKey(
    username,
    password,
    serverBValue,
    salt,
    callback
  ) {
    if (serverBValue.mod(this.N).equals(BigInteger.ZERO)) {
      throw new Error("B cannot be zero.");
    }

    this.UValue = this.calculateU(this.largeAValue, serverBValue);

    if (this.UValue.equals(BigInteger.ZERO)) {
      throw new Error("U cannot be zero.");
    }

    const usernamePassword = `${this.poolName}${username}:${password}`;
    const usernamePasswordHash = this.hash(usernamePassword);

    const xValue = new BigInteger(
      this.hexHash(this.padHex(salt) + usernamePasswordHash),
      16
    );
    this.calculateS(xValue, serverBValue, (err, sValue) => {
      if (err) {
        callback(err, null);
      }

      const hkdf = this.computehkdf(
        new global.util.Buffer(this.padHex(sValue), "hex"),
        new global.util.Buffer(this.padHex(this.UValue.toString(16)), "hex")
      );

      callback(null, hkdf);
    });
  },
};

AuthenticatioHelper.N = new BigInteger(AuthenticatioHelper.initN, 16);

AuthenticatioHelper.g = new BigInteger("2", 16);
AuthenticatioHelper.k = new BigInteger(
  AuthenticatioHelper.hexHash(
    `00${AuthenticatioHelper.N.toString(16)}0${AuthenticatioHelper.g.toString(
      16
    )}`
  ),
  16
);
AuthenticatioHelper.smallAValue = AuthenticatioHelper.generateRandomSmallA();
AuthenticatioHelper.getLargeAValue(() => {
  return;
});
AuthenticatioHelper.infoBits = new global.util.Buffer(
  "Caldera Derived Key",
  "utf8"
);

AuthenticatioHelper.poolName = config.poolData.UserPoolId.split("_")[1];

export default AuthenticatioHelper;
